module.exports = __webpack_public_path__ + "static/media/dragon_transparent.b2fe01ab.png";